import { jalaaliMonthLength } from 'jalaali-js'
import type { Category, FinanceData, Installment, Loan } from '../types'

const createdAt = '2026-08-20T21:03:43.164Z'

const categoryRows: Array<[Category['type'], string, string, string]> = [
  ['Income', 'salary', 'حقوق', '💰'], ['Income', 'project', 'درآمد پروژه‌ای', '🧩'],
  ['Income', 'bonus', 'پاداش', '🎁'], ['Income', 'overtime', 'اضافه‌کاری', '⏱️'],
  ['Income', 'eid', 'عیدی', '🌙'], ['Income', 'investment_profit', 'سود سرمایه‌گذاری', '📈'],
  ['Income', 'rent_income', 'درآمد اجاره', '🏠'], ['Income', 'other_income', 'سایر درآمدها', '➕'],
  ['Expense', 'food', 'غذا', '🍽️'], ['Expense', 'car', 'ماشین', '🚗'],
  ['Expense', 'fuel', 'سوخت', '⛽'], ['Expense', 'health', 'درمان', '🏥'],
  ['Expense', 'home', 'خانه', '🏡'], ['Expense', 'bills', 'قبض', '🧾'],
  ['Expense', 'shopping', 'خرید', '🛍️'], ['Expense', 'family', 'خانواده', '👨‍👩‍👧'],
  ['Expense', 'clothing', 'لباس', '👕'], ['Expense', 'travel', 'سفر', '🧳'],
  ['Expense', 'education', 'آموزش', '📚'], ['Expense', 'subscriptions', 'اشتراک‌ها', '🔁'],
  ['Expense', 'personal', 'شخصی', '👤'], ['Expense', 'other_expense', 'سایر', '📌'],
  ['Debt', 'lent', 'قرض دادن', '🤝'], ['Debt', 'borrowed', 'قرض گرفتن', '↩️'],
  ['Debt', 'debt', 'بدهی', '⚠️'], ['Debt', 'receivable', 'طلب', '✅'],
  ['Asset', 'gold', 'طلا', '🥇'], ['Asset', 'silver', 'نقره', '🥈'],
  ['Asset', 'currency', 'ارز', '💱'], ['Asset', 'property', 'خانه', '🏠'],
  ['Asset', 'vehicle', 'ماشین', '🚘'], ['Asset', 'land', 'زمین', '🌱'],
  ['Asset', 'shop', 'مغازه', '🏪'], ['Asset', 'financial', 'سرمایه‌گذاری مالی', '📊'],
  ['Asset', 'project_asset', 'سرمایه‌گذاری پروژه‌ای', '🏗️'], ['Asset', 'other_asset', 'سایر دارایی‌ها', '💎'],
  ['FutureExpense', 'car_insurance', 'بیمه ماشین', '🛡️'], ['FutureExpense', 'tax', 'مالیات', '🏛️'],
  ['FutureExpense', 'rent', 'اجاره', '🏘️'], ['FutureExpense', 'travel_future', 'سفر', '🧳'],
  ['FutureExpense', 'big_purchase', 'خرید بزرگ', '🛒'], ['FutureExpense', 'health_future', 'درمان', '🏥'],
  ['FutureExpense', 'tuition', 'شهریه', '🎓'], ['FutureExpense', 'renewal', 'تمدید اشتراک', '🔁'],
  ['FutureExpense', 'other_future', 'سایر', '📍'],
]

export const categories: Category[] = categoryRows.map(([type, key, name, icon], index) => ({
  id: key === 'salary' ? 'CAT_IMP_SALARY_20260821' : `CAT_PROD_${String(index + 1).padStart(3, '0')}`,
  type, key, name, icon, order: index + 1,
}))

export const loans: Loan[] = [
  ['LOAN_IMP_RESALAT81', 'رسالت ۸۱', 'بانک قرض‌الحسنه رسالت', 81, 8.1, 8, '1405/06/29', '1406/01/29', 29],
  ['LOAN_IMP_RESALAT33', 'رسالت ۳۳', 'بانک قرض‌الحسنه رسالت', 33, 3.3, 7, '1405/06/13', '1405/12/13', 13],
  ['LOAN_IMP_RESALAT5', 'رسالت ۵', 'بانک قرض‌الحسنه رسالت', 5, .5, 6, '1405/06/02', '1405/11/02', 2],
  ['LOAN_IMP_DIGIPAY', 'دیجی‌پی', 'دیجی‌پی', 100, 9.5, 4, '1405/06/10', '1405/09/10', 10],
  ['LOAN_IMP_RESALAT_ALI', 'رسالت امتیاز با علی', 'بانک قرض‌الحسنه رسالت', 37, 3.7, 4, '1405/06/21', '1405/09/21', 21],
  ['LOAN_IMP_RESALAT76', 'رسالت ۷۶', 'بانک قرض‌الحسنه رسالت', 76, 7.6, 4, '1405/06/01', '1405/09/01', 1],
  ['LOAN_IMP_MEHR', 'بانک مهر', 'بانک قرض‌الحسنه مهر ایران', 300, 9, 27, '1405/06/05', '1407/08/05', 5],
  ['LOAN_IMP_RENT', 'اجاره خانه', 'نقدی', 221, 17, 13, '1405/06/15', '1406/06/15', 15],
  ['LOAN_IMP_RESALAT175', 'رسالت ۱۷۵', 'بانک قرض‌الحسنه رسالت', 175, 11, 3, '1405/06/19', '1405/08/19', 19],
  ['LOAN_IMP_MELLAT_FARABANK', 'فرابانک ملت', 'بانک ملت', 100, 3, 34, '1405/06/08', '1408/03/08', 8],
  ['LOAN_IMP_SAMAN', 'سامان', 'بانک سامان', 250, 8, 36, '1405/06/31', '1408/05/31', 31],
  ['LOAN_IMP_MELLI', 'ملی', 'بانک ملی', 100, 3.5, 11, '1405/06/23', '1406/04/23', 23],
].map(([id, title, bankName, amount, monthlyInstallment, installmentCount, startDateJalali, endDateJalali, paymentDay]) => ({
  id: String(id), title: String(title), bankName: String(bankName), amount: Number(amount) * 1_000_000,
  monthlyInstallment: Number(monthlyInstallment) * 1_000_000, installmentCount: Number(installmentCount),
  startDateJalali: String(startDateJalali), endDateJalali: String(endDateJalali), paymentDay: Number(paymentDay),
  status: 'Active' as const,
}))

function addJalaliMonths(date: string, offset: number) {
  const [jy0, jm0, jd0] = date.split('/').map(Number)
  const zeroBased = jm0 - 1 + offset
  const jy = jy0 + Math.floor(zeroBased / 12)
  const jm = (zeroBased % 12) + 1
  const jd = Math.min(jd0, jalaaliMonthLength(jy, jm))
  return `${jy}/${String(jm).padStart(2, '0')}/${String(jd).padStart(2, '0')}`
}

export const installments: Installment[] = loans.flatMap((loan) =>
  Array.from({ length: loan.installmentCount }, (_, index) => {
    const dueDateJalali = addJalaliMonths(loan.startDateJalali, index)
    return {
      id: `INS_${loan.id.replace('LOAN_', '')}_${String(index + 1).padStart(2, '0')}`,
      loanId: loan.id, loanTitle: loan.title, bankName: loan.bankName,
      installmentNo: index + 1, dueDateJalali, monthKey: dueDateJalali.slice(0, 7).replace('/', '-'),
      amount: loan.monthlyInstallment, status: 'Pending' as const,
    }
  }),
)

export const seedData: FinanceData = {
  accounts: [
    { id: 'ACC_IMP_MAIN_20260821', title: 'حساب برنامه مالی', type: 'Other', balance: 0, notes: 'موجودی واقعی بعداً تکمیل شود' },
    { id: 'ACC_6A28C477BD12', title: 'حساب حقوق', type: 'Card', bankName: 'بانک سامان', cardLast4: '8787', balance: 0 },
  ],
  categories,
  transactions: Array.from({ length: 7 }, (_, index) => {
    const month = index + 6
    const monthKey = `1405-${String(month).padStart(2, '0')}`
    return {
      id: `TRX_IMP_SALARY_${monthKey.replace('-', '_')}`, dateJalali: monthKey.replace('-', '/') + '/01', monthKey,
      type: 'Income' as const, categoryId: 'CAT_IMP_SALARY_20260821', categoryName: 'حقوق', amount: 112_000_000,
      accountId: 'ACC_IMP_MAIN_20260821', accountTitle: 'حساب برنامه مالی', description: 'حقوق ماهانه ۱۱۲ میلیون تومان',
      postingStatus: 'Planned' as const, createdAt,
    }
  }),
  loans,
  installments,
  debts: [], futureExpenses: [], assets: [], notifications: [],
  settings: { defaultMonth: '1405-06', currency: 'Toman', remindersEnabled: true, reminderDaysBefore: 3, theme: 'Dark' },
}

export const expectedInstallmentTotals: Record<string, number> = {
  '1405-06': 84_200_000, '1405-07': 84_200_000, '1405-08': 84_200_000,
  '1405-09': 73_200_000, '1405-10': 52_400_000, '1405-11': 52_400_000, '1405-12': 51_900_000,
}
